/**
 * Expert Context Plugin for Admin Contextual Panel
 *
 * Handles expert pages: /experts/:slug
 */

import React from "react";
import { registerContext } from "../contextRegistry";
import MergeButton from "../MergeButton";

function ExpertContextPanel({ contextProps }) {
  const { slug } = contextProps;
  return (
    <div>
      <p className="small text-muted mb-2">Viewing expert: {slug}</p>
      <div className="d-grid gap-2">
        <MergeButton />
      </div>
    </div>
  );
}

// Register this context
registerContext({
  name: "expert",
  priority: 10,
  patterns: [
    {
      pattern: /\/experts\/([^/?]+)/,
      extract: (match) => ({ slug: match[1] }),
    },
  ],
  component: ExpertContextPanel,
});

export default ExpertContextPanel;
